// test958
(958 && 0);
